// class collectionTabs extends HTMLElement{
//     constructor(){
//       super();
//       this.tab_headings = this.querySelectorAll('.tab-links .heading');
//       this.tab_items = this.querySelectorAll('.tab__panel-body .tab-item');
//       this.slider_buttons = this.querySelectorAll('[data-cro-top10-prev], [data-cro-top10-next]');

//       this.tab_headings.forEach(e=>{
//         e.addEventListener('click',()=>{
//           if(e.classList.contains('active'))
//           { 
//             return;
//           }
//           this.tab_headings.forEach(ele=>{
//             ele.classList.remove('active');
//           })

//           this.tab_items.forEach(ele2=>{
//             ele2.classList.remove('active')
//           })


//           e.classList.add('active');
//           this.tab_items.forEach(ele3=>{
//             ele3.classList.remove('active')
//             if(ele3.dataset.id == e.dataset.id)
//             {
//               ele3.classList.add('active')
//             } 
//           })

//             })
//       })

//       this.slider_buttons.forEach((button) => {
//         button.addEventListener('click', () => {
//           const slider = button.closest('.cro-top10-slider');
//           const track = slider ? slider.querySelector('[data-cro-top10-track]') : null;
//           if (!track) {
//             return;
//           }

//           const direction = button.hasAttribute('data-cro-top10-prev') ? -1 : 1;
//           const scrollAmount = Math.max(track.clientWidth * 0.85, 260);
//           const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
//           const tolerance = 8;
//           let target = track.scrollLeft + scrollAmount * direction;

//           if (direction > 0 && target >= maxScroll - tolerance) {
//             target = 0;
//           } else if (direction < 0 && target <= tolerance) {
//             target = maxScroll;
//           } else {
//             target = Math.max(0, Math.min(target, maxScroll));
//           }

//           track.scrollTo({
//             left: target,
//             behavior: 'smooth'
//           });
//         });
//       });
//     }
  
//   }
//   customElements.define('collection-tabs-component', collectionTabs);

// class collectionTabs extends HTMLElement {
//   constructor() {
//     super();

//     this.tab_headings = this.querySelectorAll('.tab-links .heading');
//     this.tab_items = this.querySelectorAll('.tab__panel-body .tab-item');

//     this.tab_headings.forEach((e) => {
//       e.addEventListener('click', () => {
//         if (e.classList.contains('active')) return;

//         this.tab_headings.forEach((ele) => ele.classList.remove('active'));
//         this.tab_items.forEach((ele) => ele.classList.remove('active'));

//         e.classList.add('active');

//         this.tab_items.forEach((item) => {
//           if (item.dataset.id === e.dataset.id) {
//             item.classList.add('active');
//           }
//         });
//       });
//     });

//     this.querySelectorAll('[data-cro-top10-prev], [data-cro-top10-next]').forEach((button) => {

//       button.addEventListener('click', (e) => {

//         e.preventDefault();
//         e.stopPropagation();

//         const slider = button.closest('.cro-top10-slider');
//         if (!slider) return;

//         const track = slider.querySelector('[data-cro-top10-track]');
//         if (!track) return;

//         const direction = button.hasAttribute('data-cro-top10-prev') ? -1 : 1;

//         const scrollAmount = Math.max(track.clientWidth * 0.85, 260);

//         let target = track.scrollLeft + (scrollAmount * direction);

//         const maxScroll = track.scrollWidth - track.clientWidth;

//         if (target > maxScroll) target = 0;
//         if (target < 0) target = maxScroll;

//         track.scrollTo({
//           left: target,
//           behavior: 'smooth'
//         });

//       });

//     });

//   }
// }

// customElements.define('collection-tabs-component', collectionTabs);

class collectionTabs extends HTMLElement {
  constructor() {
    super();

    this.tab_headings = this.querySelectorAll('.tab-links .heading');
    this.tab_items = this.querySelectorAll('.tab__panel-body .tab-item');

    // Tab Switch
    this.tab_headings.forEach((heading) => {
      heading.addEventListener("click", () => {
        if (heading.classList.contains("active")) return;

        this.tab_headings.forEach((el) => el.classList.remove("active"));
        this.tab_items.forEach((el) => el.classList.remove("active"));

        heading.classList.add("active");

        this.tab_items.forEach((item) => {
          if (item.dataset.id === heading.dataset.id) {
            item.classList.add("active");
          }
        });
      });
    });

    // Slider
    this.querySelectorAll("[data-cro-top10-prev], [data-cro-top10-next]").forEach((button) => {

      button.addEventListener("click", (e) => {

        e.preventDefault();

        const slider = button.closest(".cro-top10-slider");
        if (!slider) return;

        const track = slider.querySelector("[data-cro-top10-track]");
        if (!track) return;

        // First Product Card
        const card = track.children[0];
        if (!card) return;

        // Width of one product including gap
        const cardStyle = window.getComputedStyle(card);

        const gap =
          parseFloat(cardStyle.marginLeft) +
          parseFloat(cardStyle.marginRight);

        const scrollAmount = card.offsetWidth + gap;

        const direction = button.hasAttribute("data-cro-top10-prev") ? -1 : 1;

        track.scrollBy({
          left: scrollAmount * direction,
          behavior: "smooth",
        });

      });

    });
  }
}

customElements.define("collection-tabs-component", collectionTabs);